<template>
  <div class="question-container">
    <div class="question-card">
      <h2 class="category">{{ question.category }}</h2>
      <h3 class="question-text">{{ question.text }}</h3>
      <ul class="options-list">
        <li
          v-for="option in question.options"
          :key="option.optionId"
          class="option-item"
          @click="handleAnswer(option)"
        >
          {{ option.text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { fetchQuestion, saveResponse } from "../api";

export default {
  name: "QuestionPage",
  data() {
    return {
      question: {}, // Current question data
    };
  },
  async created() {
    await this.loadQuestion(); // Fetch the initial question
  },
  watch: {
    "$route.params.questionId": "loadQuestion", // Watch for route parameter changes
  },
  methods: {
    async loadQuestion() {
      try {
      const questionId = this.$route.params.questionId || 1; // Get question ID from route or default to 1
      const response = await fetchQuestion(questionId); // Fetch question from API
      this.question = response.data;
    } catch (error) {
      console.error("Failed to fetch question:", error.response?.data || error.message);
      alert("Unable to load the question. Please try again later.");
    }
    },
    async handleAnswer(option) {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          alert("You are not authenticated. Please log in.");
          this.$router.push("/login");
          return;
        }

        // Save the user's response
        await saveResponse(
          {
            questionId: this.question.questionId,
            answer: option.text,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // Navigate to the next question
        if (option.nextQuestionId) {
          this.$router.push(`/questions/${option.nextQuestionId}`);
        } else {
          alert("Thank you! You've completed the questionnaire.");
          this.$router.push("/dashboard");
        }
      } catch (error) {
        console.error("Failed to save response:", error.response?.data || error.message);
        alert("Unable to save your response. Please try again later.");
      }
    },
  },
};
</script>

<style scoped>
.question-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.question-card {
  background: #fff;
  padding: 2rem;
  max-width: 600px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.category {
  color: #3498db;
  text-align: center;
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.question-text {
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1.25rem;
}

.options-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.option-item {
  background: #f5f7fa;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s, transform 0.3s;
  text-align: center;
  border: 1px solid #ddd;
}

.option-item:hover {
  background: #e0e7ef;
  transform: translateY(-2px);
}

.option-item:active {
  transform: translateY(0);
}
</style>




<!-- <template>
  <div>
    <h2>{{ question.category }}</h2>
    <h2>{{ question.text }}</h2>
    <ul>
      <li
        v-for="option in question.options"
        :key="option.optionId"
        @click="handleAnswer(option)"
      >
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>

<script>
import { fetchQuestion, saveResponse } from "../api";

export default {
  name: "QuestionPage",
  data() {
    return {
      question: {}, // Current question data
    };
  },
  async created() {
    await this.loadQuestion(); // Fetch the initial question
  },
  watch: {
    "$route.params.questionId": "loadQuestion", // Watch for route parameter changes
  },
  methods: {
    async loadQuestion() {
      try {
      const questionId = this.$route.params.questionId || 1; // Get question ID from route or default to 1
      const response = await fetchQuestion(questionId); // Fetch question from API
      this.question = response.data;
    } catch (error) {
      console.error("Failed to fetch question:", error.response?.data || error.message);
      alert("Unable to load the question. Please try again later.");
    }
    },
    async handleAnswer(option) {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          alert("You are not authenticated. Please log in.");
          this.$router.push("/login");
          return;
        }

        // Save the user's response
        await saveResponse(
          {
            questionId: this.question.questionId,
            answer: option.text,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // Navigate to the next question
        if (option.nextQuestionId) {
          this.$router.push(`/questions/${option.nextQuestionId}`);
        } else {
          alert("Thank you! You've completed the questionnaire.");
          this.$router.push("/dashboard");
        }
      } catch (error) {
        console.error("Failed to save response:", error.response?.data || error.message);
        alert("Unable to save your response. Please try again later.");
      }
    },
  },
};
</script> -->


<!-- <template>
  <div>
    <h2>{{ question.text }}</h2>
    <ul>
      <li
        v-for="option in question.options"
        :key="option.optionId"
        @click="handleAnswer(option)"
      >
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>

<script>
import { fetchQuestion, saveResponse } from "../api";

export default {
  name: "QuestionPage",
  data() {
    return {
      question: {},
    };
  },
  async created() {
    const questionId = this.$route.params.questionId || 1;
    const response = await fetchQuestion(questionId);
    this.question = response.data;
  },
  methods: {
    async handleAnswer(option) {
      const token = localStorage.getItem("token");
      await saveResponse(
        {
          questionId: this.question.questionId,
          answer: option.text,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      this.$router.push(`/questions/${option.nextQuestionId}`);
    },
  },
};
</script> -->
